import React from 'react';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import { logProGlobalHeaderUpgradeClicked } from '@alltrails/analytics/amplitudeFunctions';
import { FormattedMessage } from 'react-intl';
import MainButton from 'components/shared/MainButton';
import useUser from 'hooks/useUser';
import useFeatureFlags from 'hooks/useFeatureFlags';
import * as styles from './styles/styles.module.scss';

export default function UpgradeToProButton() {
  const featureFlags = useFeatureFlags();
  const user = useUser();

  return (
    <div className={styles.proButton}>
      <MainButton
        onClick={logProGlobalHeaderUpgradeClicked}
        href={checkLinkAndAppendLanguage('/pro?ref=header')}
        text={
          user.isPromoEligible && featureFlags.sevenDayTrial ? (
            <FormattedMessage defaultMessage="Try Pro for Free" />
          ) : (
            <FormattedMessage defaultMessage="Upgrade to Pro" />
          )
        }
      />
    </div>
  );
}
